.panel {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 1;
}

.panel::after {
    content: "";
    display: block;
    clear: both;
}

.panelNavi {
    width: 22%;
    height: 100%;
    border-right: 2px solid #cccccc;
    float: left;
}

.panelButtons {
    border-bottom: 2px solid #cccccc;
    padding: 5px 10px;
}

.panelMenu {
    padding: 5px 10px;
}

.panelMenuAistLink {
    text-align: center;
}

.panelContent {
    height: 100%;
    overflow: auto;
    float: right;
    padding: 5px;
    width: calc(100% - 22% - 2px);
}

.panelContent iframe {
    width: 100%;
    height: 100%;
    border: 0;
}
